import {Box, Button, Layer, Paragraph} from 'grommet'
import {CircleQuestion} from 'grommet-icons'
import {useState} from 'react'
import {FormattedMessage, useIntl} from 'react-intl'

import {TranslatedExternalLink} from '../../translation/TranslatedExternalLink'
import LayerContent from '../../ui/LayerContent'

export default function ChaveMovelInfo() {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const intl = useIntl()

  const close = () => setIsOpen(false)
  const open = () => setIsOpen(true)

  return (
    <>
      <Paragraph size="large" textAlign="center">
        <FormattedMessage
          id="login.main.chaveMovel"
          values={{
            link: (text: string) => (
              <TranslatedExternalLink
                linkId="login.chaveMovel.infoLink"
                text={text}
              />
            ),
          }}
        />{' '}
        <Button
          plain
          icon={<CircleQuestion />}
          onClick={open}
          title={intl.formatMessage({id: 'common.moreInfo'})}
        />
      </Paragraph>

      {isOpen && (
        <Layer
          id="chave-movel-info"
          position="center"
          onClickOutside={close}
          onEsc={close}
        >
          <LayerContent>
            <Box pad="medium" justify="start" align="center" overflow="auto">
                <Paragraph size="large" textAlign="center">
                  <FormattedMessage
                    id="login.chaveMovel.info"
                    values={{
                      link: (text: string) => (
                        <TranslatedExternalLink
                          linkId="login.chaveMovel.infoLink"
                          text={text}
                        />
                      ),
                    }}
                  />
                </Paragraph>

                <Button
                  primary
                  onClick={close}
                  label={intl.formatMessage({id: 'common.close'})}
                />
            </Box>
          </LayerContent>
        </Layer>
      )}
    </>
  )
}
